import { FormGroup } from '@angular/forms';
import { createPersonForm } from '@base/factories/person-form.factory';
import { createPaymentForm } from '@base/factories/payment-form.factory';
import { createLegalCheckForm, ElektronikLegalCheckFormModel } from './tech-legal-check-form.factory';
import { PersonFormModel } from '@base/models/form/person-form.model';
import { PaymentFormModel } from '@base/models/form/payment-form.model';
import { createKaufpreisProductForm, ElektronikProductFormModel } from './tech-product-form.factory';

export function createElektronikForm(): FormGroup<ElektronikFormModel> {
  return new FormGroup<ElektronikFormModel>({
    person: createPersonForm(),
    product: createKaufpreisProductForm(),
    payment: createPaymentForm(),
    legalCheck: createLegalCheckForm()
  });
}

export interface ElektronikFormModel {
  person: FormGroup<PersonFormModel>;
  product: FormGroup<ElektronikProductFormModel>;
  payment: FormGroup<PaymentFormModel>;
  legalCheck: FormGroup<ElektronikLegalCheckFormModel>;
}